import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getConfig = () => api.get("/config").then((r) => r.data);

export const createCheckout = (payload) =>
  api.post("/checkout/session", payload).then((r) => r.data);

export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);

export const verifyAccessCode = (code) =>
  api.post("/access/code", { code }).then((r) => r.data);

export const submitSurvey = (payload) =>
  api.post("/survey/submit", payload).then((r) => r.data);

export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);

export const getAdminData = (password) =>
  api.get("/admin/data", { headers: { "X-Admin-Password": password } }).then((r) => r.data);

export const getAdminSubmission = (password, id) =>
  api.get(`/admin/submission/${id}`, { headers: { "X-Admin-Password": password } }).then((r) => r.data);
